import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { materialTableMui412CompatComponents } from '../../utils/materialTableMui412Compat';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';

function Perfil() {
  const [columns, setColumns] = useState([{ title: 'Nome', field: 'nome' }]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');
  const [perfis, setPerfis] = useState([]);

  useEffect(() => {
    const fetchPerfis = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/perfil`)
        .then((res) => {
          setPerfis(res.data);
        })
        .catch((err) => {
          console.log(err);
          setAlertType('error');
          setMessage('Erro ao carregar os perfis,tente novamente mais tarde!');
          setAlert(true);
        });
    };

    fetchPerfis();
  }, []);

  return (
    <div style={{ margin: 20 }}>
      <Collapse in={alert}>
        <Alert severity={alertType} onClick={() => setAlert(false)}>
          {message}
        </Alert>
      </Collapse>
      <MaterialTable
        title="Perfis"
        columns={columns}
        data={perfis}
        components={materialTableMui412CompatComponents}
        editable={{
          onRowAdd: (newData) =>
            new Promise(async (resolve, reject) => {
              await instanceAxios(localStorage.getItem('toobiauth'))
                .post(`${environment}/perfil`, newData)
                .then((res) => {
                  setPerfis([...perfis, newData]);
                  setAlertType('success');
                  setMessage('Perfil Criado com Sucesso!');
                  setAlert(true);
                  resolve();
                })
                .catch((err) => {
                  console.log(err);
                  setAlertType('error');
                  setMessage(
                    'Erro ao criar perfil,tente novamente mais tarde!'
                  );
                  setAlert(true);
                  resolve();
                });
            }),
          onRowUpdate: (newData, oldData) =>
            new Promise(async (resolve, reject) => {
              console.log(`${environment}/perfil/${newData.id}`);
              await instanceAxios(localStorage.getItem('toobiauth'))
                .put(`${environment}/perfil/${newData.id}`, newData)
                .then((res) => {
                  const pfs = perfis.map((p) =>
                    p.id === newData.id ? newData : p
                  );
                  setPerfis(pfs);
                  setAlertType('success');
                  setMessage('Perfil editado com Sucesso!');
                  setAlert(true);
                  resolve();
                })
                .catch((err) => {
                  console.log(err);
                  setAlertType('error');
                  setMessage(
                    'Erro ao editar perfil,tente novamente mais tarde!'
                  );
                  setAlert(true);
                  resolve();
                });
            }),
          onRowDelete: (oldData) =>
            new Promise(async (resolve, reject) => {
              await instanceAxios(localStorage.getItem('toobiauth'))
                .delete(`${environment}/perfil/${oldData.id}`)
                .then((res) => {
                  const perfilDelete = [...perfis];
                  const index = oldData.tableData.id;
                  perfilDelete.splice(index, 1);
                  setPerfis([...perfilDelete]);
                  setAlertType('success');
                  setMessage('Perfil excluido com Sucesso!');
                  setAlert(true);
                  resolve();
                })
                .catch((err) => {
                  console.log(err);
                  setAlertType('error');
                  setMessage(
                    'Erro ao excluir perfil,tente novamente mais tarde!'
                  );
                  setAlert(true);
                  resolve();
                });
            }),
        }}
        localization={{
          pagination: {
            labelDisplayedRows: '{from}-{to} de {count}',
          },
          header: {
            actions: 'Ações',
          },
          body: {
            emptyDataSourceMessage: 'Sem data para mostrar',
            filterRow: {
              filterTooltip: 'Filtro',
            },
            editRow: {
              deleteText: 'Você tem certeza que deseja excluir Esse Perfil?',
            },
          },
        }}
      />
    </div>
  );
}

export default Perfil;
